import { Col, Row, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import { getUserStatus } from "../../../models/user/enum";
import { getBannerType } from "../../../models/banner-charity/enum";
import BannerCategoryContext from "../../../context/banner-charity/context";
import EndPoints from "../../../services/end-points";
import { ICharity } from "../../../models/charity/response";
import AppContext from "../../../context/app/context";

interface IProps { }

const BannerCategoryFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(BannerCategoryContext);
  const statuses = [1, 2];
  const [charities, setCharities] = useState<ICharity[]>([]);
  const { direction } = useContext(AppContext);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const { data } = await EndPoints.charity.getAllCharities({
          light: true,
          perPage: -1,
        });
        const newOptions = data?.data;
        setCharities((prevOptions) => [...prevOptions, ...newOptions]);
      } catch (error) {
        console.log(error);
      }
    };
    getCategories();
  }, [direction]);
  return (
    <Form
      formId="charity-banner-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: data?.keyword,
          filters: [
            data?.status
              ? {
                name: "status",
                value: data.status,
                operation: "eq",
              }
              : undefined,
            data?.type
              ? {
                name: "type",
                value: data.type,
                operation: "eq",
              }
              : undefined,
            data?.charity_id
              ? {
                name: "charity_id",
                value: data.charity_id,
                operation: "eq",
              }
              : undefined,
          ].filter((f) => f),
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col span={8}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              options: statuses.map((status, index) => {
                return {
                  label: t(getUserStatus(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
        <Col span={8}>
          <FieldBuilder
            name="type"
            label={`${t("type")}`}
            width="large"
            input={{
              type: "select",
              options: [1, 2, 3, 4, 5, 6].map((status, index) => {
                return {
                  label: t(getBannerType(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
        <Col span={8}>
          <FieldBuilder
            name="charityId"
            label={`${t("charity")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              options: charities?.map((cat, index) => {
                return {
                  key: index,
                  label: cat.name,
                  value: cat.id,
                };
              }),
            }}
          />
        </Col>

      </Row>
    </Form>
  );
};

export default BannerCategoryFilter;
